// extracted by mini-css-extract-plugin
export default {"separator":"OrSeparator_separator__9SJX7","line":"OrSeparator_line__d4yJ6","text":"OrSeparator_text__27QFM"};